import { createContext } from 'react';
import { DetailPageActionType } from '../hook/useDetailPageContext';

export type DetailPageType = 'detail' | 'edit' | 'add';
export interface IBaseDetailPageContext {
  visible?: boolean;
  pageType?: DetailPageType;
}
export interface IDetailPageContext extends IBaseDetailPageContext {
  dispatchDetailPage: (
    type: DetailPageActionType,
    payload: IBaseDetailPageContext,
  ) => void;
}

export default createContext<IDetailPageContext>({
  visible: false,
  dispatchDetailPage: () => {},
});
